import { render } from "./AboutPageDesc.vue?vue&type=template&id=4becfc32&scoped=true"
const script = {}

import "./AboutPageDesc.vue?vue&type=style&index=0&id=4becfc32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4becfc32"]])

export default __exports__